import { Action, createActions } from '@common/types/actions';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Clip } from '../types';

import { DeliveryModal } from '@features/delivery/components/DeliveryModal';
import { SendDialog, useSendModal } from '@features/send';
import { ShareDialog, useShareModal } from '@features/share';
import { PaperPlaneIcon, Share1Icon } from '@radix-ui/react-icons';
import { mapClipToSendableItem } from '../utils/mapClipToSendableItem';
import { mapClipToShareableItem } from '../utils/mapClipToShareableItem';

export const useClipActions = () => {
    const { t } = useTranslation(['clipTable']);
    const share = useShareModal();
    const send = useSendModal();

    const baseActions: Action<Clip>[] = useMemo(
        () =>
            createActions<Clip>([
                {
                    label: t('actions.share'),
                    color: 'gray',
                    icon: <Share1Icon />,
                    onClick: (items) =>
                        share.openShare(items.map(mapClipToShareableItem)),
                },
                {
                    label: t('actions.send'),
                    color: 'gray',
                    icon: <PaperPlaneIcon />,
                    onClick: (items) =>
                        send.openSend(items.map(mapClipToSendableItem)),
                },
            ]),
        [send, share, t],
    );

    const ClipActionModals = () => (
        <>
            <DeliveryModal.Root value={share.dialogProps}>
                <ShareDialog />
            </DeliveryModal.Root>
            <DeliveryModal.Root value={send.dialogProps}>
                <SendDialog />
            </DeliveryModal.Root>
        </>
    );

    return { baseActions, ClipActionModals };
};
